import React from "react";

const WebAppConfig = React.createContext({
  webAppConfig: [],
});

export { WebAppConfig };
